import { ColumnDef } from "@tanstack/react-table";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { moneyFormat } from "../../../../../helpers/appHelpers";

// Helper functions
const formatDate = (params: any) => {
	if (!params.value) return "";
	const date = new Date(params.value);
	return date.toLocaleDateString();
};

const enumToStringConverter = (value: string) => {
	if (!value) return "";
	return value
		.split("_")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join(" ");
};

export const SubscriptionPackagesColumns: ColumnDef<any>[] = [
	{
		accessorKey: "name",
		header: "Name",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "description",
		header: "Description",
		size: 350,
		minSize: 250,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "priceAmount",
		header: "Price",
		size: 220,
		minSize: 180,
		cell: ({ row }) => {
			const amount = row.original.priceAmount;
			const currency = row.original.currency;
			return `${currency?.code || ""} ${moneyFormat(amount)}`;
		},
	},
	{
		accessorKey: "netAmount",
		header: "Net Price",
		size: 220,
		minSize: 180,
		cell: ({ row }) => {
			const amount = row.original.netAmount;
			const currency = row.original.currency;
			return `${currency?.code || ""} ${moneyFormat(amount)}`;
		},
	},
	{
		accessorKey: "maxUsers",
		header: "Max Users",
		size: 160,
		minSize: 120,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "maxCompanies",
		header: "Max Companies",
		size: 180,
		minSize: 130,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "maxEmployees",
		header: "Max Employees",
		size: 180,
		minSize: 130,
		cell: ({ getValue }) => getValue(),
	},
	{
		accessorKey: "billingPeriod",
		header: "Billing Period",
		size: 180,
		minSize: 130,
		cell: ({ getValue }) => enumToStringConverter(getValue() as string),
	},
	{
		accessorKey: "plan",
		header: "Plan",
		size: 180,
		minSize: 130,
		cell: ({ getValue }) => enumToStringConverter(getValue() as string),
	},
	{
		accessorKey: "promotion",
		header: "Promotion",
		size: 220,
		minSize: 180,
		cell: ({ getValue }) => {
			const promotion = getValue() as any;
			return promotion?.title || "--";
		},
	},
	{
		accessorKey: "country",
		header: "Country",
		size: 220,
		minSize: 180,
		cell: ({ getValue }) => {
			const country = getValue() as any;
			return country?.name || "--";
		},
	},
	{
		accessorKey: "createdAt",
		header: "Date Created",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		accessorKey: "modifiedAt",
		header: "Date Modified",
		size: 200,
		minSize: 150,
		cell: ({ getValue }) => formatDate({ value: getValue() }),
	},
	{
		id: "actions",
		header: "Actions",
		size: 100,
		minSize: 80,
		cell: ({ row, table }) => {
			const meta = table.options.meta as any;
			return (
				<button
					onClick={(e) => {
						e.stopPropagation();
						if (meta?.onActionClick) {
							meta.onActionClick(row.original, e);
						}
					}}
					className="p-2 hover:bg-gray-100 rounded-full transition-colors"
				>
					<BiDotsHorizontalRounded className="text-xl" />
				</button>
			);
		},
	},
];

export const PromotionsColumnVisibilityModel: Record<string, boolean> = {
	name: true,
	description: true,
	priceAmount: true,
	netAmount: true,
	maxUsers: true,
	maxCompanies: true,
	maxEmployees: true,
	billingPeriod: true,
	plan: true,
	promotion: false,
	country: false,
	createdAt: true,
	modifiedAt: true,
};
